// extracted by mini-css-extract-plugin
export var sliderRange = "_cv-2";
export var sliderRoot = "_cv-0";
export var sliderThumb = "_cv-3";
export var sliderTrack = "_cv-1";